(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bienalia-purge"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-bn-image]');
  if (!button) return;
  const root = button.closest('.bn');
  const hero = root.querySelector('.bn-hero');
  if (hero) { hero.removeAttribute('srcset'); hero.src = button.dataset.bnImage; hero.alt = button.getAttribute('aria-label'); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
